import React from "react";

import UserNewsletterSubscriptions from "../../molecules/UserNewsletterSubscriptions";
import ProfileContainer from "../../rows/ProfileContainer";

const list = [
  { name: "All Sections", type: "Daily" },
  { name: "Entertainments", type: "Monthly" },
  { name: "Sports", type: "Daily" },
  { name: "Movies", type: "Weekly" }
];

const UserNewslettersPage = () => (
  <ProfileContainer type="newsletters" hideTopAd={true}>
    <UserNewsletterSubscriptions list={list} />
  </ProfileContainer>
);

export { UserNewslettersPage };
